<template>
    <PullContainer
            ref="pullContainerRef"
            :pullDownLabel="true"
            :pullDownLoading="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container mobile_approval_center_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                    </ReturnNavBar>
                </div>
                <div class="top_tab_wrap">
                    <ul>
                        <li
                                v-for="item in approval_tab_list"
                                :key="item.state"
                                :class="{ active: searchForm.processState == item.state }"
                                @click="handleClickApprovalTabChange(item)"
                        >
                            <span v-if="item.state == 'awaiting_my_action'"
                            >{{ item.name }}
                                {{ stateTypeNum.pending_num > 0 ? stateTypeNum.pending_num : "" }}</span
                            >
                            <span v-else-if="item.state == 'received_by_me'"
                            >{{ item.name }}
                                {{ stateTypeNum.received_num > 0 ? stateTypeNum.received_num : "" }}</span
                            >
                            <span v-else>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
                <div class="top_search">
                    <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @clear="onSearch"
                            @search="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="unRead_status" v-if="searchForm.processState == 'received_by_me'">
                    <el-checkbox v-model="searchForm.isOnlyUnReadStatus">仅看未读</el-checkbox>
                    <span>标记为已读</span>
                </div>
                <div class="mobile_container">
                    <div class="approval_center_list">
                        <ul v-infinite-scroll="onLoadList">
                            <li v-for="item in tableData" :key="item.approval_id" class="approval_list_item">
                                <div class="approval_list_item_title">
                                    <h5 v-text="item.approval_set ? item.approval_set.name : ''"></h5>
                                    <span>ID:{{ item.approval_id }}</span>
                                    <span :class="'approval_status_' + item.approval_status" class="approval_status">
                                         {{ getApprovalStatusText(item.approval_status) }}
                                     </span>
                                </div>
                                <div class="approval_list_item_detail">
                                    <div class="approval_list_item_detail_top">
                                        <div class="img_info">
                                            <div class="img_avatar_wrap">
                                                <img :src="item.creator_info && item.creator_info.avatar ? item.creator_info.avatar : defaultImg"
                                                     alt=""/>
                                            </div>
                                            <span>{{ item.creator_info && item.creator_info.name }}</span>
                                        </div>
                                        <span class="time">{{ searchForm.processState === "awaiting_my_action" ? "申请时间：" : searchForm.processState === "already_handled_by_me" ? "处理时间：" : "" }}{{
                                                item.created_at
                                            }}</span>
                                    </div>
                                    <div :ref="'approve' + item.approval_id + '_detail_wrap'"
                                         :class="{ hidden_content: item.is_expand == false }"
                                         class="approval_list_item_detail_content"
                                         v-if="!loading && item.approval_content && item.approval_content.content">
                                        <CustomFormDetailMobile
                                                v-if="item.approval_content && item.approval_content.content && item.approval_content.content.form_value_details"
                                                ref="customFormPc"
                                                :business_data="item.approval_content.content.business_data"
                                                :field_list="item.approval_content.content && item.approval_content.content.custom_details"
                                                :form_detail="item.approval_content.content && item.approval_content.content.form_value_details"
                                                :is_edit_mode="false"
                                                :pk_id="item.approval_id"/>
                                        <!--系统审批详情-->
                                        <SystemApprovalDetail
                                                v-if=" item.approval_content && item.approval_content.content &&  item.approval_content.content.details"
                                                :approvalDetailInfo="item"
                                                :approval_type="item.approval_type"
                                                :business_data="item.approval_content.content.business_data"
                                                :form_detail="item.approval_content.content.details"/>
                                    </div>
                                    <div v-if="item.isShowExpanded" class="approval_list_item_expand_icon">
                                        <span v-if="!item.is_expand" @click="handleClickChangeExpandState(item, true)">展开<van-icon
                                                name="arrow-down"/></span>
                                        <span v-else @click="handleClickChangeExpandState(item, false)">收起<van-icon
                                                name="arrow-up"/></span>
                                    </div>
                                </div>
                                <div class="approval_list_item_process">
                                    <div class="approval_list_title_wrap"><span>审批流程</span></div>
                                    <approvalProcessDetails
                                            :approvalNodeList="item.node_list"
                                            :approvalStatus="item.approval_status"
                                            :currentUserApprovalPermission="item.button"
                                            @cancelAddSignSuccess="cancelAddSignSuccess"></approvalProcessDetails>
                                </div>

                                <div class="approval_list_item_bottom">
                                    <div class="handle_icon_btn_wrap_left">
                                        <div v-if="item.button && item.button.button && item.button.button.comment_button"
                                             class="handle_icon_btn_item"
                                             @click="handleClickComment(item)">
                                            <i class="iconfont icon-pinglun"></i>
                                            <span>评论</span>
                                        </div>
                                        <div v-if="item.button && item.button.button && item.button.button.copy_button"
                                             class="handle_icon_btn_item"
                                             @click="handleClickMake(itme)">
                                            <i class="iconfont icon-chaosong"></i>
                                            <span>抄送</span>
                                        </div>
                                        <div :class="{handle_icon_btn_item_disabled: item.button &&  item.button.button && !item.button.button.cancel_button,}"
                                             class="handle_icon_btn_item"
                                             @click="handleClickRevokeConfirm(item)">
                                            <i class="iconfont icon-chexiao"></i>
                                            <span>撤销</span>
                                        </div>
                                        <div v-if="item.button && item.button.button &&
                                                 (item.button.button.transfer_button || item.button.button.add_signature_button || item.button.button.return_button || item.button.button.submit_again_button) " class="handle_icon_btn_item"
                                             @click="handleClickMoreOperate(item)">
                                            <i class="iconfont icon-gengduo"></i>
                                            <span>更多</span>
                                        </div>
                                    </div>
                                    <div class="handle_icon_btn_wrap_right">
                                        <span v-if="item.button && item.button.button && item.button.button.rejection_button && (item.node_list.find((item) => item.need_operation == 1) && item.node_list.find((item) => item.need_operation == 1).type !='conduct')"
                                              class="reject_btn"
                                              @click="handleClickAgreeAndReject('reject', item)">拒绝</span>
                                        <div v-if=" item.button && item.button.button && (item.button.button.pass_button || item.button.button.quick_pass_button)"
                                             class="agreen_btn">
                                            <span v-if="item.button && item.button.button && item.button.button.pass_button"
                                                  class="span_text"
                                                  @click="handleClickAgreeAndReject('agree', item)"
                                                  v-text="(item.node_list.find((item) => item.need_operation == 1) && item.node_list.find((item) => item.need_operation == 1).type == 'conduct') ? '确认' : '同意' "></span>
                                            <span v-if="item.button && item.button.button && item.button.button.quick_pass_button"
                                                  class="span_icon"
                                                  @click="handleClickQuickAgreeConfirm(item)">
                                                 <i class="iconfont icon-shandian"></i>
                                             </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <p v-if="loading">加载中...</p>
                    </div>
                </div>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
            </div>
            <!-- 更多操作按钮 -->
            <van-overlay
                    v-if="showRadioPicker"
                    :custom-style="{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 999 }"
                    :show="showRadioPicker"
            >
                <div class="radio_option_wrap">
                    <ul class="radio_option_list">
                        <li
                                v-if="
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.submit_again_button
                            "
                                class="radio_option_item"
                                @click="handleClickRadioOption('submit_again_button')"
                        >
                            再次提交
                        </li>
                        <li
                                v-if="
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.transfer_button
                            "
                                class="radio_option_item"
                                @click="handleClickRadioOption('transfer_button')"
                        >
                            转交
                        </li>
                        <li
                                v-if="
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.add_signature_button
                            "
                                class="radio_option_item"
                                @click="handleClickRadioOption('add_signature_button')"
                        >
                            加签
                        </li>
                        <li
                                v-if="
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.return_button
                            "
                                class="radio_option_item"
                                @click="handleClickRadioOption('return_button')"
                        >
                            回退
                        </li>
                        <li
                                :class="{
                                radio_option_item_disabled:
                                    currentUserApprovalPermission.button &&
                                    !currentUserApprovalPermission.button.is_edit_auth,
                            }"
                                class="radio_option_item"
                                @click="handleClickRadioOption('is_edit')"
                        >
                            修改
                        </li>
                    </ul>
                    <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
                </div>
            </van-overlay>
            <!-- 同意和拒绝 -->
            <van-popup
                    v-if="showAgreeAndRejectPopup"
                    v-model="showAgreeAndRejectPopup"
                    :style="{ width: '100%', height: '452px', borderRadius: '8px 8px 0 0' }"
                    position="bottom"
                    @close="handleAgreeAndRejectPopupClose"
            >
                <div class="text_popoup_wrap">
                    <div class="text_popoup_wrap_title">
                        <span>{{ currentPopupText }}</span>
                        <span @click="handleAgreeAndRejectPopupClose">取消</span>
                    </div>
                    <div class="text_popoup_content">
                        <van-field
                                v-model="currentPopupSuggestion"
                                autosize
                                label=""
                                maxlength="200"
                                placeholder="请输入审批意见"
                                rows="12"
                                show-word-limit
                                type="textarea"
                        />
                    </div>
                    <van-button type="info" :disabled="btnDisabled" @click="handleClickConfirm">{{
                            currentPopupText
                        }}
                    </van-button>
                </div>
            </van-popup>
            <!-- 评论 -->
            <van-popup
                    v-if="showCommentPopup"
                    v-model="showCommentPopup"
                    :style="{ width: '100%', height: '452px', borderRadius: '8px 8px 0 0' }"
                    position="bottom"
                    @close="handleCommentPopupClose"
            >
                <div class="text_popoup_wrap">
                    <div class="text_popoup_wrap_title">
                        <span>添加评论</span>
                        <span @click="handleCommentPopupClose">取消</span>
                    </div>
                    <div class="text_popoup_content">
                        <commentComponent ref="commentComponentRef" :placeholderText="'请输入评论'"></commentComponent>
                    </div>
                    <van-button type="info" @click="handleClickCommentConfirm" :disabled="btnDisabled">发送</van-button>
                </div>
            </van-popup>
            <!-- 高级筛选 -->
            <van-popup
                    v-if="searchPopupShow"
                    v-model="searchPopupShow"
                    :close-on-click-overlay="false"
                    :style="{ height: '70%', background: '#F7F8FA' }"
                    position="bottom"
                    round
            >
                <div class="search_popup_wrap">
                    <div class="search_popup_header">
                        <div class="arrow_left_icon"></div>
                        <div class="title" v-text="'筛选'"></div>
                        <div class="right_btn_wrap" @click="searchPopupShow = false">
                            <van-icon name="arrow-down"/>
                        </div>
                    </div>
                    <div class="search_popup_content">
                        <ul>
                            <li>
                                <p class="search_item_title">状态</p>
                                <div class="tag_wrap">
                                    <div class="tag_item" @click="handleClickStatusFilter('')">
                                        <span
                                                :class="{ 'active': searchForm.approval_status.length == 0 }"
                                                class="tag_item_status"
                                        >全部</span
                                        >
                                    </div>
                                    <div class="tag_item" @click="handleClickStatusFilter(1)">
                                        <span
                                                :class="{ 'active': searchForm.approval_status.includes(1) }"
                                                class="tag_item_status"
                                        >已通过</span
                                        >
                                    </div>
                                    <div class="tag_item" @click="handleClickStatusFilter(2)">
                                        <span
                                                :class="{ 'active': searchForm.approval_status.includes(2) }"
                                                class="tag_item_status"
                                        >已拒绝</span
                                        >
                                    </div>
                                    <div class="tag_item" @click="handleClickStatusFilter(0)">
                                        <span
                                                :class="{ 'active': searchForm.approval_status.includes(0) }"
                                                class="tag_item_status"
                                        >审批中</span
                                        >
                                    </div>
                                    <div class="tag_item" @click="handleClickStatusFilter(3)">
                                        <span
                                                :class="{ 'active': searchForm.approval_status.includes(3) }"
                                                class="tag_item_status"
                                        >已撤回</span
                                        >
                                    </div>
                                </div>
                            </li>
                            <li>
                                <p class="search_item_title">类型</p>
                                <div class="tag_wrap">
                                    <div class="tag_item" @click="handleClickTypeFilter('')">
                                        <span
                                                :class="{ 'active': searchForm.approval_type.length == 0 }"
                                                class="tag_item_status"
                                        >全部</span
                                        >
                                    </div>
                                    <div v-for="type in approvalSetTypeList" :key="type.id" class="tag_item"
                                         @click="handleClickTypeFilter(type.id)">
                                        <span
                                                :class="{ 'active': searchForm.approval_type.includes(type.id) }"
                                                class="tag_item_status"
                                        >{{ type.name }}</span
                                        >
                                    </div>
                                </div>
                            </li>
                            <li class="pb_10">
                                <p class="search_item_title">审批发起时间</p>
                                <div class="search_item_tiem_wrap" @click="handleClickDateRange">
                                    <span>{{ searchForm.customDateText ? searchForm.customDateText : "请选择" }}</span>
                                    <i class="iconfont icon-rili"></i>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="search_popup_btns">
                        <van-button type="default" @click="handleClickFilterReset">重置</van-button>
                        <van-button type="info" @click="handleClickFilterConfirm">确认</van-button>
                    </div>
                </div>
            </van-popup>
            <!--日期区间选择-->
            <van-calendar
                    v-model="showDateRangePicker"
                    :allow-same-day="true"
                    :max-date="dateCalendarMax"
                    :min-date="dateCalendarMin"
                    :show-confirm="false"
                    color="#1990FF"
                    type="range"
                    @close="showDateRangePicker = false"
                    @confirm="handleClickRangeCalendarConfirm"
            >
            </van-calendar>
            <!-- 人员选择 -->
            <UserSearchSelect
                    v-if="userSelectVisible"
                    :userSelectTitle="userSelectTitle"
                    :userSelectVisible.sync="userSelectVisible"
                    @selectUserData="handleSelectUserData"
            />
        </template>
    </PullContainer>
</template>
<script>
import {formatDate} from "@/utils";
import {mapState} from "vuex";
import {pagination} from "@/mixins";
import {Dialog} from "vant";
import {
    GetMobileApprovalList,
    passApproval,
    cancelApproval,
    rejectionApproval,
    approvalAddSign,
    approvalSubtractSign,
    approvalTransfer,
    GetUserList,
    approvalFallback,
    addComment,
    commentList,
    copyToSomeone,
    ApprovalStateTypeNum,
    AllApprovalSetList,
} from "@/api";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import commentComponent from "./component/commentComponent";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile.vue";
import approvalProcessDetails from "@/components/pComponents/approvalProcessDetails";
import SystemApprovalDetail from "@/components/mComponents/systemApprovalDetail";

export default {
    name: "mobileApprovalCenter",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        approvalProcessDetails,
        UserSearchSelect,
        commentComponent,
        CustomFormDetailMobile,
        SystemApprovalDetail
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            searchForm: {
                keyword: "",
                processState: "awaiting_my_action",
                customDate: [], //自定义时间
                customDateText: "",
                approval_status: [], //审批状态
                approval_type: [], // 类型
                isOnlyUnReadStatus: false,
            },
            approval_tab_list: [
                {
                    state: "awaiting_my_action",
                    name: "待处理",
                    icon: "icon-shenpidaichuli",
                    activeIcon: "icon-shenpidaichuli_xuanzhong",
                    total: "100",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "already_handled_by_me",
                    name: "已处理",
                    icon: "icon-shenpiyichuli",
                    activeIcon: "icon-shenpiyichuli_xuanzhong",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "received_by_me",
                    name: "我收到",
                    icon: "icon-shenpiwoshoudao",
                    activeIcon: "icon-shenpiwoshoudao_xuanzhong",
                    total: "0",
                    isPackUp: false,
                },
                {
                    state: "initiated_by_me",
                    name: "我发起",
                    icon: "icon-shenpiwoshoudao",
                    activeIcon: "icon-shenpiwoshoudao_xuanzhong",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
            ],
            stateTypeNum: {
                pending_num: 0, // 待审批数量
                received_num: 0, // 已收到数量（未读数量）
            }, // 审批数量
            // approvalNodeList: [], // 审批流程
            approvalDetailInfo: null, // 审批详情
            currentUserApprovalPermission: {
                button: {},
                approval_people_id: "",
            }, // 当前用户的可操作按钮权限
            // 更多
            showRadioPicker: false, // 更多按钮选择
            moreOperateType: "",
            // 同意拒绝
            showAgreeAndRejectPopup: false, // 同意和拒绝弹框
            currentPopupText: "同意",
            currentPopupState: "", // 同意:agree, 拒绝：reject
            currentPopupSuggestion: "",
            showCommentPopup: false, // 评论
            // 高级筛选
            searchPopupShow: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            showDateRangePicker: false,
            approvalStatusList: [], // 审批状态
            approvalSetTypeList: [], // 审批类型
            // 人员
            userSelectVisible: false,
            userSelectTitle: "",
            selectUserData: {},
            // 按钮状态
            popupLoading: false,
            btnDisabled: false,
            // 权限数据
            approvalId: "", // 当前审批id
            // 列表数据
            tableData: [],
            finishedList: true, //可以上拉加载
            // 当前操作数据
            currentApproval: {}, // 当前需要操作的节点信息
            carbonCopyUserIds: [], // 所有流程中的用户
            tabBarActive: 1,
            tabBarList: [
                {
                    icon: "icon-faqishenpi",
                    activeIcon: "icon-faqishenpi_xuanzhong",
                    routerName: "mobileApproval",
                    title: "发起审批",
                },
                {
                    icon: "icon-shenpi_weixuanzhong",
                    activeIcon: "icon-shenpi_xuanzhong",
                    routerName: "mobileApprovalCenter",
                    title: "审批中心",
                },
            ],
            pullDownLoading: false, //是否是下拉刷新

        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        if (this.$route.query && this.$route.query.processState) {
            this.searchForm.processState = this.$route.query.processState;
        }
        this.getApproveStateTypeNum();
        this.getAllApprovalSetList()
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true
                this.initData()
            }
        },
        // 状态切换
        handleClickApprovalTabChange(item) {
            this.searchForm.processState = item.state;
            this.initData();
        },
        onSearch() {
            this.initData();
        },
        // 高级筛选
        handleClickAdvancedFilter() {
            this.searchPopupShow = true;
        },
        // 选择日期区间
        handleClickDateRange() {
            this.dateCalendarMin = new Date("2015-01-01");
            this.dateCalendarMax = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
            this.showDateRangePicker = true;
        },
        //点击日期区间选择器确定事件
        async handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.searchForm.customDateText = value[0] + " - " + value[1];
            this.searchForm.customDate = value;
            this.showDateRangePicker = false;
        },
        // 审批状态筛选
        handleClickStatusFilter(status) {

            if (status == '' && status !== 0) {
                this.searchForm.approval_status = []
            } else {
                if (this.searchForm.approval_status.includes(status)) {
                    const index = this.searchForm.approval_status.indexOf(status)
                    this.searchForm.approval_status.splice(index, 1)
                } else {
                    this.searchForm.approval_status.push(status)
                }
            }
        },
        // 审批类型筛选
        handleClickTypeFilter(type_id) {
            if (type_id == '') {
                this.searchForm.approval_type = []
            } else {
                if (this.searchForm.approval_type.includes(type_id)) {
                    const index = this.searchForm.approval_type.indexOf(type_id)
                    this.searchForm.approval_type.splice(index, 1)
                } else {
                    this.searchForm.approval_type.push(type_id)
                }
            }
        },
        // 重置
        handleClickFilterReset() {
            this.searchForm.approval_type = []
            this.searchForm.approval_status = []
            this.searchForm.customDate = []
            this.searchForm.customDateText = ''
            this.searchPopupShow = false
            this.initData(this.searchForm.processState)
        },
        // 高级筛选确认
        handleClickFilterConfirm() {
            this.searchPopupShow = false
            this.initData(this.searchForm.processState)
        },
        // 更多操作
        handleClickMoreOperate(item) {
            // 当前需要操作的节点
            const node_item = item.node_list.find((item) => item.need_operation == 1);
            let currentApproval = node_item || {};
            this.currentApproval = currentApproval;
            this.approvalId = item.approval_id;

            // 当前的操作按钮权限
            let buttons = item.button || {};
            // 判断是否有修改权限
            if (item.creator_uid == this.owner_uid && item.node_list.length && item.node_list.length > 1) {
                // 1. 发起人可以对已发起但第一个节点未被审批的审批单进行修改
                if (item.node_list[1].need_operation == 1) {
                    buttons.button.is_edit_auth = true;
                    buttons.button.edit_auth_tooltip = "";
                } else {
                    buttons.button.is_edit_auth = false;
                    buttons.button.edit_auth_tooltip = "当前审批已被审批无法修改，如需修改可以撤销后重新发起";
                }
            } else if (item.field_auth && item.field_auth.length) {
                //  2. 当前节点人员可以对有编辑权限的字段修改--通过后台流程设置表单权限设置中设置
                if (item.field_auth.filter((field) => field.field_auth == 2).length) {
                    buttons.button.is_edit_auth = true;
                    buttons.button.edit_auth_tooltip = "";
                } else {
                    buttons.button.is_edit_auth = false;
                    buttons.button.edit_auth_tooltip = "您没有对该审批单的修改权限";
                }
            } else {
                buttons.button.is_edit_auth = false;
                buttons.button.edit_auth_tooltip = "";
            }
            this.currentUserApprovalPermission = buttons;
            this.showRadioPicker = true;
        },
        // 更多操作确认
        handleClickRadioOption(type) {
            this.moreOperateType = type;
            switch (type) {
                case "transfer_button":
                    this.userSelectTitle = "选择转交人员";
                    this.userSelectVisible = true;
                    break;
                case "add_signature_button":
                    this.userSelectTitle = "选择加签人员";
                    this.userSelectVisible = true;
                    break;
                case "return_button":
                    // 回退
                    this.handleClickBackConfirm();
                    break;
                case "submit_again_button":
                    // 再次提交
                    break;
                case "is_edit":
                    // 修改
                    break;
            }
        },
        // 同意和拒绝
        handleClickAgreeAndReject(state, item) {
            // 当前需要操作的节点
            const node_item = item.node_list.find((item) => item.need_operation == 1);
            let currentApproval = node_item || {};
            this.currentApproval = currentApproval;
            this.approvalId = item.approval_id;
            this.currentPopupState = state;
            this.currentPopupText = state == "agree" ? "同意" : "拒绝";
            this.currentPopupSuggestion = "";
            this.showAgreeAndRejectPopup = true;
        },
        // 同意和拒绝取消
        handleAgreeAndRejectPopupClose() {
            this.showAgreeAndRejectPopup = false;
            this.currentPopupSuggestion = "";
        },
        handleClickConfirm() {
            if (this.currentPopupState == "agree") {
                // 同意
                this.handleClickAgreeConfirm();
            } else {
                // 拒绝
                this.handleClickRefuseConfirm();
            }
        },
        // 审批同意确定
        handleClickAgreeConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: this.currentPopupSuggestion,
                };
                passApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$toast({
                                    message: this.currentApproval.type == 'conduct' ? '已确认' : '已同意',
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                            this.btnDisabled = false;
                            this.handleAgreeAndRejectPopupClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批拒绝确定
        handleClickRefuseConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: this.currentPopupSuggestion,
                };
                rejectionApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$toast({
                                    message: "已拒绝",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                            this.btnDisabled = false;
                            this.handleAgreeAndRejectPopupClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批快速通过
        handleClickQuickAgreeConfirm(item) {
            // 当前需要操作的节点
            const node_item = item.node_list.find((item) => item.need_operation == 1);
            let currentApproval = node_item || {};
            this.currentApproval = currentApproval;
            this.approvalId = item.approval_id;
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: "",
                };
                passApproval(params).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: this.currentApproval.type == 'conduct' ? '已确认' : '已同意',
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.initData(this.searchForm.processState);
                            },
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            }
        },
        // 审批撤销确定
        handleClickRevokeConfirm(item) {
            if (!item.button.button.cancel_button) return;
            // 当前需要操作的节点
            const node_item = item.node_list.find((item) => item.need_operation == 1);
            let currentApproval = node_item || {};
            this.currentApproval = currentApproval;
            this.approvalId = item.approval_id;
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                };
                cancelApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$toast({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 加签
        handleClickCountersignConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (!this.selectUserData.uid) return this.$toast("请选择加签人员");
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    user_id: this.selectUserData.uid,
                    approval_mode:this.currentApproval.approval_mode
                };
                approvalAddSign(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.selectUserData = {};
                                this.$toast({
                                    message: "加签成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                                this.selectUserData = {};
                                this.showRadioPicker = false;
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                            this.btnDisabled = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 转交
        handleClickTransferConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (!this.selectUserData.uid) return this.$toast("请选择转交人员");
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    user_id: this.selectUserData.uid,
                };
                approvalTransfer(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.selectUserData = {};
                                this.$toast({
                                    message: "转交成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                                this.selectUserData = {};
                                this.showRadioPicker = false;
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                            this.btnDisabled = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 去评论
        handleClickComment(item) {
            this.approvalId = item.approval_id;
            this.showCommentPopup = true;
        },
        // 评论取消
        handleCommentPopupClose() {
            this.showCommentPopup = false;
        },
        // 评论确定发送
        handleClickCommentConfirm() {
            let data = this.$refs.commentComponentRef.getCommentContent();
            if (!data.content && !data.at_uid && !data.files.length && !data.img.length)
                return this.$toast("请输入些内容");
            const params = {
                approval_id: this.approvalId,
                atPeople: data.at_people,
                file_list: data.files,
                content: data.content,
                pic_list: data.img,
            };
            this.btnDisabled = true;
            addComment(params).then((res) => {
                if (res.code === 200) {
                    this.$toast({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.initData(this.searchForm.processState);
                        },
                    });
                } else {
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
                this.btnDisabled = false;
                this.handleCommentPopupClose();
            });
        },
        // 抄送
        handleClickMake(item) {
            this.approvalId = item.approval_id;
            this.approvalDetailInfo = item
            // 当前需要操作的节点
            const node_item = item.node_list.find((item) => item.need_operation == 1);
            let currentApproval = node_item || {};
            this.currentApproval = currentApproval;

            this.userSelectTitle = "选择抄送人员";
            this.userSelectVisible = true;
        },
        // 抄送确定
        handleClickMakeConfirm() {
            // 查找需要操作的流程节点
            // 没处理的审批获取当前待办的节点
            // status == 1 已通过的审批获取结束节点
            // status == 2 驳回的获取驳回的那个节点
            // 否则都不满足是最后一个节点
            let  node_id = ''
            if(this.approvalDetailInfo.status  == 0){
                node_id =  this.currentApproval ? this.currentApproval.node_id : this.approvalDetailInfo.node_list[this.approvalDetailInfo.node_list.length-1].node_id;
            }else if(this.approvalDetailInfo.status  == 1){
                node_id = this.approvalDetailInfo.node_list[this.approvalDetailInfo.node_list.length-1].node_id;
            }else if(this.approvalDetailInfo.status  == 2){
                node_id = this.approvalDetailInfo.node_list.find(find => find.status == 2)?.node_id
            }else{
                node_id = this.approvalDetailInfo.node_list[0].node_id;
            }
            if (!this.approval_handle_form.make_uid.length) return this.$toast("请选择抄送人员");
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    cc_uids: this.approval_handle_form.make_uid,
                };
                copyToSomeone(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.selectUserData = {};
                                this.$toast({
                                    message: "转交成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.initData(this.searchForm.processState);
                                    },
                                });
                            } else {
                                this.$toast({
                                    message: res.message,
                                    type: "fail",
                                });
                            }
                            this.approvalDetailInfo = null
                            this.btnDisabled = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批回退确定
        handleClickBackConfirm() {
            if (this.currentApproval && this.currentApproval.sort == 2) {
                this.$toast("第一个节点不允许回退");
                return false
            }
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                Dialog.confirm({
                    title: "回退",
                    message: "确定回退至上一节点？",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                    confirmButtonText: "确定",
                })
                        .then(() => {
                            this.btnDisabled = true;
                            approvalFallback({approval_id: this.approvalId, node_id})
                                    .then((res) => {
                                        if (res.code === 200) {
                                            this.$toast({
                                                message: "回退成功",
                                                type: "success",
                                                duration: 1000,
                                                onClose: () => {
                                                    this.initData(this.searchForm.processState);
                                                },
                                            });
                                        } else {
                                            this.$toast({
                                                message: res.message,
                                                type: "fail",
                                            });
                                        }
                                        this.btnDisabled = false;
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                    });
                        })
                        .catch(() => {
                        });
            }
        },
        // 选择人员
        handleSelectUserData(data) {
            this.selectUserData = data;
            if (this.moreOperateType == "add_signature_button") {
                // 加签
                this.handleClickCountersignConfirm();
            } else if (this.moreOperateType == "transfer_button") {
                // 转交
                this.handleClickTransferConfirm();
            } else {
                // 抄送
                this.handleClickMakeConfirm();
            }
        },
        // 数据展开和折叠
        handleClickChangeExpandState(item, state) {
            this.$set(item, "is_expand", state);
        },
        // 取消加签后回调
        cancelAddSignSuccess(approval_id) {
            this.tableData = this.tableData.filter(item => item.approval_id != approval_id);
        },
        // 初始化数据
        initData(state) {
            this.getApproveStateTypeNum();
            this.onPullRefreshList();
        },
        // 获取审批状态
        getApprovalStatusText(approval_status) {
            let text = "";
            switch (approval_status) {
                case 0:
                    text = "审批中";
                    break;
                case 1:
                    text = "已通过";
                    break;
                case 2:
                    text = "已拒绝";
                    break;
                case 3:
                    text = "已撤销";
                    break;
            }
            return text;
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.finishedList = true;
            this.tableData = [];
            this.getApprovalList();
        },
        onLoadList() {
            if (this.finishedList) {
                this.getApprovalList();
            }
        },
        // 审批自定义字段数据
        getCustomFieldsData(field_list) {
            let data = {};
            field_list.forEach((item) => {
                data[item.field_key] = item.field_value;
            });
            return data;
        },
        // 审批列表
        getApprovalList() {
            this.finishedList = false
            GetMobileApprovalList({
                type: this.searchForm.processState,
                page: this.pagination.pageNum,
                keyword: this.searchForm.keyword,
                pageSize: 10,
                approval_set_id: this.searchForm.approval_type,
                date_range: this.searchForm.customDateText,
                approval_status: this.searchForm.approval_status
            }).then((res) => {
                if (res.code === 200) {
                    let {list, total} = res.data;
                    list.forEach((item) => {
                        if (item.approval_content && item.approval_content.content && item.approval_content.content.custom_details) {
                            item.approval_content.content.form_value_details = this.getCustomFieldsData(item.approval_content.content.custom_details);
                        }
                    });
                    this.tableData = this.tableData.concat(list);
                    this.$nextTick(() => {
                        this.tableData.forEach(item => {
                            if (this.$refs[`approve${item.approval_id}_detail_wrap`] && this.$refs[`approve${item.approval_id}_detail_wrap`][0]) {

                                if (this.$refs[`approve${item.approval_id}_detail_wrap`][0].clientHeight > 200) {
                                    item.isShowExpanded = true
                                    this.$set(item, 'is_expand', false)
                                } else {
                                    item.isShowExpanded = false
                                }
                            }
                        })
                    })

                    this.finishedList = list.length == 0 ? false : true; //上滑列表加载完了所有数据（没有更多了）
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');

                    }
                }
            });
        },
        // 获取状态类型数量
        getApproveStateTypeNum() {
            ApprovalStateTypeNum().then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    this.stateTypeNum.pending_num = data.pending_num;
                    this.stateTypeNum.received_num = data.received_num;
                }
            });
        },
        // 获取所有审批类型
        getAllApprovalSetList() {
            AllApprovalSetList({keyword: ""}).then((res) => {
                if (res.code === 200) {
                    this.approvalSetTypeList = res.data || [];
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.top_tab_wrap {
    height: 56px;
    background-color: #ffffff;
    padding: 8px 10px;

    ul {
        display: flex;
    }

    li {
        flex: 1;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }

        &.active,
        &:active {
            background: rgba(41, 144, 255, 0.05);

            span {
                font-weight: 700;
                color: rgba(41, 144, 255, 1);
            }
        }
    }
}

.top_search {
    padding: 6px 16px;
    background: rgba(255, 255, 255, 1);

    .van-search {
        padding: 0;
        border-radius: 6px;
        background-color: rgba(243, 243, 243, 1);
        overflow: hidden;

        .van-cell {
            padding-right: 12px;
        }

        .van-search__content {
            background-color: rgba(243, 243, 243, 1);

            ::v-deep {
                .van-icon-search {
                    color: rgba(51, 51, 51, 1);
                }
            }
        }

        .van-field__right-icon {
            .icon-shaixuan {
                color: rgba(102, 102, 102, 1);
                font-size: 12px;
            }
        }
    }
}

.unRead_status {
    margin: 10px 16px;
    height: 38px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .el-checkbox {
        .el-checkbox__inner {
            width: 16px;
            height: 16px;
        }

        ::v-deep {
            .el-checkbox__label {
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);
            }
        }
    }

    & > span {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(41, 144, 255, 1);
    }
}

.mobile_approval_center_wrap {
    .approval_center_list {
        padding: 10px 16px;

        .approval_list_item {
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            padding: 0 10px;
            margin-bottom: 10px;

            .approval_list_item_title {
                height: 42px;
                border-bottom: 1px solid rgba(243, 243, 243, 1);
                display: flex;
                align-items: center;

                h5 {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-right: 6px;
                }

                span {
                    font-size: 12px;
                }

                .approval_status {
                    margin-left: 10px;
                    width: 52px;
                    min-width: 44px;
                    height: 22px;
                    line-height: 20px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 400;
                    text-align: center;
                }

                .approval_status_0 {
                    color: #fbad13;
                    border-color: #fbad13;
                    background: rgba(251, 173, 19, 0.1);
                }

                .approval_status_1 {
                    color: #52c41b;
                    border-color: #52c41b;
                    background: rgba(82, 196, 27, 0.1);
                }

                .approval_status_2 {
                    color: #ff4d4f;
                    border-color: #ff4d4f;
                    background: rgba(255, 77, 79, 0.1);
                }

                .approval_status_3 {
                    color: #bfbfbf;
                    border-color: #bfbfbf;
                    background: rgba(191, 191, 191, 0.1);
                }
            }

            .approval_list_item_detail_top {
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .time {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }
            }

            .approval_list_item_detail_content {
                padding-top: 10px;

                &.hidden_content {
                    max-height: 200px;
                    overflow: hidden;
                }
            }

            .approval_list_item_expand_icon {
                margin-top: 10px;
                text-align: center;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);

                .van-icon {
                    margin-left: 6px;
                }
            }

            .img_info {
                border-radius: 14px;
                background: rgba(237, 240, 244, 1);
                padding: 1px 8px 1px 1px;
                height: 22px;
                display: flex;
                align-items: center;
                width: fit-content;

                .img_avatar_wrap {
                    display: inline-block;
                    vertical-align: top;
                    width: 20px;
                    height: 20px;
                    opacity: 1;
                    background: rgba(255, 255, 255, 1);
                    padding: 1px;
                    border-radius: 50%;
                    overflow: hidden;

                    img {
                        width: 18px;
                        height: 18px;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-left: 9px;
                }
            }

            .approval_list_title_wrap {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 20px;
            }

            .approval_list_item_process {
                margin-top: 10px;
                border-radius: 6px;
                background: rgba(243, 243, 243, 0.5);
                padding: 10px;
            }

            .approval_list_item_bottom {
                margin-top: 10px;
                height: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .handle_icon_btn_wrap_left {
                    display: flex;
                    gap: 4px;
                }

                .handle_icon_btn_wrap_right {
                    display: flex;
                    gap: 10px;
                }

                .handle_icon_btn_item {
                    min-width: 40px;
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    align-items: center;
                    color: rgba(102, 102, 102, 1);

                    .iconfont {
                        font-size: 14px;
                    }

                    .icon-chaosong {
                        display: block;
                        width: 14px;
                        height: 14px;
                        background: url("https://download.hecoos.com/enlightv/2024-52/6d5514af03014985253dc37e6d0292a4.png") no-repeat;
                        background-size: cover;
                    }

                    span {
                        margin-top: 3px;
                        font-size: 10px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 14.48px;
                        color: rgba(102, 102, 102, 1);
                    }

                    &.handle_icon_btn_item_disabled {
                        color: rgba(153, 153, 153, 1);
                        pointer-events: none;
                        cursor: not-allowed;

                        span {
                            color: rgba(153, 153, 153, 1);
                        }
                    }
                }

                .reject_btn {
                    width: 40px;
                    height: 26px;
                    border-radius: 2px;
                    border: 1px solid rgba(255, 77, 79, 1);
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 24px;
                    text-align: center;
                    color: rgba(255, 77, 79, 1);

                    &:active {
                        background: rgba(255, 77, 79, 0.1);
                    }
                }

                .agreen_btn {
                    border-radius: 4px;
                    background: rgb(255, 255, 255);
                    border: 1px solid rgb(41, 144, 255);
                    min-width: 40px;
                    height: 26px;
                    line-height: 24px;
                    text-align: center;
                    display: flex;
                    color: rgba(41, 144, 255, 1);
                    cursor: pointer;

                    .span_text {
                        width: 40px;
                    }

                    .span_icon {
                        width: 28px;
                        position: relative;

                        &:before {
                            width: 1px;
                            height: 12px;
                            top: 7px;
                            left: 0;
                            content: " ";
                            background: rgba(232, 232, 232, 1);
                            position: absolute;
                        }

                        .iconfont {
                            font-size: 12px;
                        }
                    }

                    span:active {
                        background: rgba(41, 144, 255, 0.16);
                        color: rgba(34, 121, 214, 1);
                    }
                }
            }
        }
    }
}

.radio_option_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .radio_option_list {
        max-height: calc(100% - 90px);
        overflow-y: auto;

        .radio_option_item {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #dedede;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }

            &.radio_option_item_disabled {
                color: rgba(153, 153, 153, 1);
                pointer-events: none;
                cursor: not-allowed;
            }
        }
    }

    .cancel_btn {
        background-color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}

.text_popoup_wrap {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px, 0px, 0px;
    background: rgba(247, 248, 250, 1);
    padding: 0 16px 10px;
    display: flex;
    flex-direction: column;

    .text_popoup_wrap_title {
        height: 50px;
        position: relative;

        span:nth-child(1) {
            line-height: 44px;
            display: block;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }

        span:nth-child(2) {
            position: absolute;
            top: 11px;
            right: 0;
            color: rgba(41, 144, 240, 1);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
        }
    }

    .text_popoup_content {
        flex: 1;
        background-color: #ffffff;
    }

    .van-button {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        height: 42px;
    }
}

.search_popup_wrap {
    width: 100%;
    height: 100%;
    background-color: rgba(247, 248, 250, 1);
    display: flex;
    flex-direction: column;
}

.search_popup_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    line-height: 24px;

    .arrow_left_icon {
        width: 16px;
        height: 16px;
    }

    .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: #333333;
    }

    .right_btn_wrap {
        width: 24px;

        .van-icon {
            color: rgba(102, 102, 102, 1);
            font-size: 24px;
        }
    }
}

.search_popup_content {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px 12px;

    .pb_10 {
        padding-bottom: 10px;
    }

    li {
        margin-bottom: 6px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        padding: 10px 0 0;

        .search_item_title {
            padding: 0 10px 16px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(0, 0, 0, 1);
        }

        .tag_wrap {
            display: flex;
            flex-wrap: wrap;
        }

        .tag_item {
            padding: 0 10px;
            width: 25%;
            height: 26px;
            margin-bottom: 10px;
        }

        .tag_item_status {
            display: block;
            width: 100%;
            height: 26px;
            text-align: center;
            padding: 4px 8px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(102, 102, 102, 1);
            opacity: 1;
            border-radius: 6px;
            background: rgba(247, 248, 250, 1);
            overflow: hidden;
            white-space: noWrap;
            text-overflow: ellipsis;

            &.active {
                background-color: rgba(41, 144, 255, 0.16);
                color: rgba(41, 144, 255, 1);
            }
        }

        .search_item_tiem_wrap {
            margin: 0 10px;
            height: 26px;
            opacity: 1;
            border-radius: 6px;
            background: rgba(247, 248, 250, 1);
            padding: 4px 12px 4px 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);
            }

            .iconfont {
                color: rgba(153, 153, 153, 1);
                font-size: 12px;
            }
        }
    }
}

.search_popup_btns {
    padding: 10px 16px;
    display: flex;
    gap: 8px;

    .van-button {
        flex: 1;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 400;
    }

    .van-button--default {
        border: 0;
        color: rgba(41, 144, 240, 1);
    }
}
</style>
